"use client";

import { c as _c } from "react/compiler-runtime";
import { Link } from "@/components/Link/Link.component";
import { Translation } from "@/components/Translation/Translation.component";
import { usePaywall } from "@/contexts/paywall/paywall.context";
export function ProductPageLink() {
  const $ = _c(4);
  const {
    shopLinks: t0
  } = usePaywall();
  const {
    consumerUrl
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Translation da="Er du interesseret i et personligt abonnement eller virksomhedsabonnement?" de={"Interessieren Sie sich f\xFCr ein pers\xF6nliches Abonnement oder Firmenabonnement?"} en="Are you interested in a personal subscription or corporate subscription?" no="Er du interessert i et personlig abonnement eller bedriftsabonnement?" sv={"\xC4r du intresserad av en personlig prenumeration eller f\xF6retagsprenumeration?"} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Translation da={" L\xE6s om vores abonnementer her"} de={" Lesen Sie \xFCber unsere Abonnements hier"} en=" Read about our subscriptions here" no={" Les om v\xE5re abonnementer her"} sv={" L\xE4s om v\xE5ra prenumerationer h\xE4r"} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== consumerUrl) {
    t3 = <div>{t1}{" "}<Link className="text-primary hover:text-primary-hover hover:underline" href={consumerUrl} position="pw-pp-a" testId="product-page-link">{t2}</Link></div>;
    $[2] = consumerUrl;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}